export default /* html */ `<slot></slot>`
